import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments, updateFaqsNotesDocuments, deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectFaqs } from '../../store/selectors/faqsNotesDocuments';
import Faqs from '../../components/Faqs';
import { selectFormOptions } from '../../store/selectors/formOptions';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/upLoadHelper';
import { fetchAllIssueTypes } from '../../store/actions/formOptions';
import { clearFndFormData } from '../../store/actions/fndForm';

class AssetFaqs extends Component {
  componentDidMount() {
    const { asset,clearSearch, onFetchAllIssueTypes } = this.props;
    clearSearch()
    onFetchAllIssueTypes();
    this.props.clearFndFormData()
  }

  onSave = async (faq) => {
    const {  asset,onSaveFaqsNotesDocuments,onUpdateFaqsNotesDocuments  } = this.props;
    let image=null
    // if(faq.selectedImage && faq.selectedImage.length > 0){
    //   image =  await upload(faq.selectedImage[0])
    //   faq = faq = {...faq,image}
    //   }
      // delete faq.selectedImage;
      if(faq.uploadType==="Image"&& faq.image && faq.image.length > 0){
        
        image =  await upload(faq.image[0])
        faq = faq = {...faq,image}
      }
      faq = {...faq, question: faq.question?.trim(), issue: faq.issue?.trim()}
      if(faq && faq.linkTitle) {
        faq = {...faq, linkTitle: faq.linkTitle?.trim()}
      }
      if(faq && faq.caption) {
        faq = {...faq, caption: faq.caption?.trim()}
      }
    if(faq.id){
      let data = {
        "id": faq.id,
        "ItemId": asset.item.id,
        "Name": 'Frequently Asked Questions',
        "Type": 'FAQS',
        "data": JSON.stringify(faq).toString(),
        "UserId": this.props.user.id
      }
     onUpdateFaqsNotesDocuments(data)

    }else{
      onSaveFaqsNotesDocuments(
        {
              ItemId: asset.item.id,
              Name: 'Frequently Asked Questions',
              Type: 'FAQS',
              Data: JSON.stringify(faq).toString(),
              UserId: this.props.user.id
            }
      )
        }
  }

  render() {
    const { faqs, onDeleteFaqsNotesDocuments,setSearch } = this.props;
    return (
      <Faqs
        faqs={faqs}
        onSaveFaq={ faq => this.onSave(faq)}
        onDeleteFaq={ faq => {onDeleteFaqsNotesDocuments({...faq,Type:'FAQS'})}}

        onSearch={e => setSearch({ faqs: e.target.value?.trim() })}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  faqs: selectFaqs(state),
  formOptions: selectFormOptions(state),
  

});

const mapDispatchToProps = dispatch => bindActionCreators({
  onSaveFaqsNotesDocuments: saveFaqsNotesDocuments,
  onUpdateFaqsNotesDocuments:updateFaqsNotesDocuments,
  onDeleteFaqsNotesDocuments:deleteFaqsNotesDocuments,
  setSearch,
  clearSearch,
  onFetchAllIssueTypes:fetchAllIssueTypes,
  clearFndFormData,

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AssetFaqs);
